import FeatureRolloutLogPerformanceConstants from "./FeatureRolloutLogPerformanceConstants.js";
function loadStart(clientTimeInMs) {
  return {
    type: FeatureRolloutLogPerformanceConstants.LOAD_START,
    payload: { clientTimeInMs }
  };
}
function checkOverviewMainFunctionality(clientTimeInMs) {
  return {
    type: FeatureRolloutLogPerformanceConstants.CHECK_OVERVIEW_MAIN_FUNCTIONALITY,
    payload: { clientTimeInMs }
  };
}
function setOverviewMainFunctionality(clientTimeInMs) {
  return {
    type: FeatureRolloutLogPerformanceConstants.SET_OVERVIEW_MAIN_FUNCTIONALITY,
    payload: { clientTimeInMs }
  };
}
function checkProgressionsMainFunctionality(clientTimeInMs) {
  return {
    type: FeatureRolloutLogPerformanceConstants.CHECK_PROGRESSIONS_MAIN_FUNCTIONALITY,
    payload: { clientTimeInMs }
  };
}
function setProgressionsMainFunctionality(clientTimeInMs) {
  return {
    type: FeatureRolloutLogPerformanceConstants.SET_PROGRESSIONS_MAIN_FUNCTIONALITY,
    payload: { clientTimeInMs }
  };
}
function checkOverviewFullLoad(clientTimeInMs) {
  return {
    type: FeatureRolloutLogPerformanceConstants.CHECK_OVERVIEW_FULL_LOAD,
    payload: { clientTimeInMs }
  };
}
function setOverviewFullLoad(clientTimeInMs) {
  return {
    type: FeatureRolloutLogPerformanceConstants.SET_OVERVIEW_FULL_LOAD,
    payload: { clientTimeInMs }
  };
}
function checkProgressionsFullLoad(clientTimeInMs) {
  return {
    type: FeatureRolloutLogPerformanceConstants.CHECK_PROGRESSIONS_FULL_LOAD,
    payload: { clientTimeInMs }
  };
}
function setProgressionsFullLoad(clientTimeInMs) {
  return {
    type: FeatureRolloutLogPerformanceConstants.SET_PROGRESSIONS_FULL_LOAD,
    payload: { clientTimeInMs }
  };
}
function checkProgressionsScorecardsFullLoad(clientTimeInMs) {
  return {
    type: FeatureRolloutLogPerformanceConstants.CHECK_PROGRESSIONS_SCORECARDS_FULL_LOAD,
    payload: { clientTimeInMs }
  };
}
function setProgressionsScorecardsFullLoad(clientTimeInMs) {
  return {
    type: FeatureRolloutLogPerformanceConstants.SET_PROGRESSIONS_SCORECARDS_FULL_LOAD,
    payload: { clientTimeInMs }
  };
}
function checkAlertsFullLoad(clientTimeInMs) {
  return {
    type: FeatureRolloutLogPerformanceConstants.CHECK_ALERTS_FULL_LOAD,
    payload: { clientTimeInMs }
  };
}
function setAlertsFullLoad(clientTimeInMs) {
  return {
    type: FeatureRolloutLogPerformanceConstants.SET_ALERTS_FULL_LOAD,
    payload: { clientTimeInMs }
  };
}
function mainFunctionality(timeSinceLoadStartInMs, lastPartToLoad) {
  return {
    type: FeatureRolloutLogPerformanceConstants.MAIN_FUNCTIONALITY,
    payload: { timeSinceLoadStartInMs, lastPartToLoad }
  };
}
function fullLoad(timeSinceLoadStartInMs, lastPartToLoad) {
  return {
    type: FeatureRolloutLogPerformanceConstants.FULL_LOAD,
    payload: { timeSinceLoadStartInMs, lastPartToLoad }
  };
}
export {
  checkAlertsFullLoad,
  checkOverviewFullLoad,
  checkOverviewMainFunctionality,
  checkProgressionsFullLoad,
  checkProgressionsMainFunctionality,
  checkProgressionsScorecardsFullLoad,
  fullLoad,
  loadStart,
  mainFunctionality,
  setAlertsFullLoad,
  setOverviewFullLoad,
  setOverviewMainFunctionality,
  setProgressionsFullLoad,
  setProgressionsMainFunctionality,
  setProgressionsScorecardsFullLoad
};
//# sourceMappingURL=FeatureRolloutLogPerformanceActions.js.map
